import type { AnyRouter } from "@tanstack/react-router"
import { useSearch } from "@tanstack/react-router"

import { COMPANY_EDIT_ROUTE } from "../constants"
import type { ProductSearchFilters } from "../products/stores/useProductsSearchStore"

export const useCompanyEditSearch = (): ProductSearchFilters => {
  const currentSearch = useSearch<AnyRouter, undefined, true, ProductSearchFilters>({
    from: COMPANY_EDIT_ROUTE,
  })

  return currentSearch
}
